"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const menuLinks_1 = __importDefault(require("./menuLinks"));
const counterTitles_1 = __importDefault(require("./counterTitles"));
const messages_1 = __importDefault(require("./messages"));
const buttonTitles_1 = __importDefault(require("./buttonTitles"));
const ownershipTitles_1 = __importDefault(require("./ownershipTitles"));
const headerTitles_1 = __importDefault(require("./headerTitles"));
const tabTitles_1 = __importDefault(require("./tabTitles"));
const labels_1 = __importDefault(require("./labels"));
const validateMessages_1 = __importDefault(require("./validateMessages"));
const tooltipTitles_1 = __importDefault(require("./tooltipTitles"));
const modals_1 = __importDefault(require("./modals"));
const settings_1 = __importDefault(require("./settings"));
const popover_1 = __importDefault(require("./popover"));
const whatsappModalHint_1 = __importDefault(require("./whatsappModalHint"));
const spam_1 = __importDefault(require("./spam"));
const avatar_1 = __importDefault(require("./avatar"));
const contactDetails_1 = __importDefault(require("./contactDetails"));
const hintTitles_1 = __importDefault(require("./hintTitles"));
const appeals_1 = __importDefault(require("./appeals"));
exports.default = {
  counterTitles: counterTitles_1.default,
  menuLinks: menuLinks_1.default,
  messages: messages_1.default,
  buttonTitles: buttonTitles_1.default,
  ownershipTitles: ownershipTitles_1.default,
  headerTitles: headerTitles_1.default,
  tabTitles: tabTitles_1.default,
  labels: labels_1.default,
  validateMessages: validateMessages_1.default,
  tooltipTitles: tooltipTitles_1.default,
  modals: modals_1.default,
  settings: settings_1.default,
  popover: popover_1.default,
  hintWhatsapp: whatsappModalHint_1.default,
  spam: spam_1.default,
  avatar: avatar_1.default,
  contactDetails: contactDetails_1.default,
  hintTitles: hintTitles_1.default,
  appeals: appeals_1.default
};